.dec-file-field {
  --dec-file-accent-soft: var(--bs-primary-bg-subtle, #e7f1ff);
  --dec-file-border: var(--bs-border-color, #dee2e6);
  --dec-file-muted: var(--bs-secondary-color, #6c757d);
  --dec-file-surface: var(--bs-tertiary-bg, #f8f9fa);
}

.dec-file-field__label {
  align-items: baseline;
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.dec-file-field__required {
  color: var(--bs-danger, #dc3545);
  margin-inline-start: 0.25rem;
}

.dec-file-field__hint,
.dec-file-field__metadata {
  color: var(--dec-file-muted);
  font-size: 0.875rem;
}

.dec-file-field__hint {
  font-weight: 400;
}

.dec-file-field__empty {
  align-items: center;
  background: var(--dec-file-surface);
  border: 1px dashed var(--dec-file-border);
  border-radius: var(--bs-border-radius, 0.375rem);
  color: var(--bs-body-color, #212529);
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  min-height: 5.5rem;
  padding: 1rem;
  width: 100%;
}

.dec-file-field__empty--readonly {
  color: var(--dec-file-muted);
}

.dec-file-field .dec-file-field__shell {
  align-items: center;
  background: #fff;
  border: 1px solid #d6dbe3;
  border-radius: 0.625rem;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 0.5rem 0.625rem;
}

.dec-file-field__identity {
  align-items: center;
  display: flex;
  min-width: 0;
}

.dec-file-field .dec-file-field__document-icon {
  align-items: center;
  background: var(--dec-file-accent-soft);
  border-radius: 0.5rem;
  color: var(--bs-primary, #0d6efd);
  display: flex;
  flex: 0 0 2.25rem;
  font-size: 1.125rem;
  height: 2.25rem;
  justify-content: center;
  margin-right: 0.625rem;
  width: 2.25rem;
}

.dec-file-field__details {
  min-width: 0;
}

.dec-file-field__name {
  color: var(--bs-body-color, #212529);
  display: block;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dec-file-field__metadata,
.dec-file-field__success,
.dec-file-field__progress,
.dec-file-field__error,
.dec-file-field__actions {
  align-items: center;
  display: flex;
}

.dec-file-field__metadata {
  gap: 0.375rem;
  margin-top: 0.125rem;
}

.dec-file-field__success {
  color: #198754;
  font-weight: 500;
  gap: 0.2rem;
}

.dec-file-field__progress {
  color: var(--bs-primary, #0d6efd);
  gap: 0.375rem;
}

.dec-file-field__actions {
  gap: 0.375rem;
}

.dec-file-field .dec-file-field__action {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  color: #6b7280;
  display: inline-flex;
  height: 2.625rem;
  justify-content: center;
  padding: 0;
  width: 2.625rem;
}

.dec-file-field .dec-file-field__action--danger {
  color: #dc3545;
}

.dec-file-field__empty:hover:not(:disabled),
.dec-file-field .dec-file-field__action:hover:not(:disabled) {
  background: var(--dec-file-surface);
  border-color: var(--dec-file-border);
}

.dec-file-field__empty:focus-visible,
.dec-file-field .dec-file-field__action:focus-visible {
  outline: 2px solid var(--bs-primary, #0d6efd);
  outline-offset: 2px;
}

.dec-file-field__error {
  color: var(--bs-danger, #dc3545);
  gap: 0.375rem;
  margin-top: 0.5rem;
}

@media (max-width: 679.98px) {
  .dec-file-field .dec-file-field__shell {
    gap: 0.75rem;
    grid-template-columns: minmax(0, 1fr);
  }

  .dec-file-field__actions {
    border-top: 1px solid var(--dec-file-border);
    justify-content: flex-end;
    padding-top: 0.75rem;
  }
}
